import { render, staticRenderFns } from "./Shfw.vue?vue&type=template&id=581746fe&scoped=true"
import script from "./Shfw.vue?vue&type=script&lang=js"
export * from "./Shfw.vue?vue&type=script&lang=js"
import style0 from "./Shfw.vue?vue&type=style&index=0&id=581746fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581746fe",
  null
  
)

export default component.exports